import * as angular from "angular";
import {IWindowService} from "angular";
import {SplitService} from "./split-service.service";
import {BillingOrderStatusType} from "../../billing-accounts/types/billing-order-status.type";
import {InvoiceStatusType} from "../../billing-accounts/types/invoice-status.type";
import {DateRangeTemplateType} from "../types/date-range-template.type";

export class ViewFilterSettingsService {

  storage: any;

  constructor(private $window: IWindowService, private splitService: SplitService) {
    this.storage = this.$window.localStorage;
  }

  getActiveQuickFilter(pageName: string) {
    const siteId = this.splitService.getSiteId();
    let quickFilterIdContext = angular.fromJson(this.$window.localStorage.getItem('activeQuickFilter'));
    let currentUserId = angular.fromJson(this.$window.localStorage.getItem('user')).id;

    if (!quickFilterIdContext) {
      quickFilterIdContext = {};
    }

    return quickFilterIdContext[siteId] && quickFilterIdContext[siteId][pageName] ? quickFilterIdContext[siteId][pageName][currentUserId] : undefined;
  }

  setActiveQuickFilter(activeQuickFilter: any, pageName: string) {
    let quickActiveFilterContext = angular.fromJson(this.$window.localStorage.getItem('activeQuickFilter'));
    let currentUserId = angular.fromJson(this.$window.localStorage.getItem('user')).id;
    const siteId = this.splitService.getSiteId();

    if (!quickActiveFilterContext) {
      quickActiveFilterContext = {};
    }
    if (!quickActiveFilterContext[siteId]) {
      quickActiveFilterContext[siteId] = {};
    }

    if (!quickActiveFilterContext[siteId][pageName]) {
      quickActiveFilterContext[siteId][pageName] = {};
    }

    quickActiveFilterContext[siteId][pageName][currentUserId] = activeQuickFilter;
    this.$window.localStorage.setItem('activeQuickFilter', angular.toJson(quickActiveFilterContext));
  }

  getPageFilters<T>(pageName: string): T | undefined {
    const siteId = this.splitService.getSiteId();
    const pageFiltersContext = angular.fromJson(this.$window.localStorage.getItem('pageFilters'));
    const currentUserId = angular.fromJson(this.$window.localStorage.getItem('user'))?.id;

    return pageFiltersContext?.[siteId]?.[pageName]?.[currentUserId];
  }

  setPageFilters<T>(filters: T, pageName: string) {
    let pageFiltersContext = angular.fromJson(this.$window.localStorage.getItem('pageFilters'));
    const currentUserId = angular.fromJson(this.$window.localStorage.getItem('user'))?.id;
    const siteId = this.splitService.getSiteId();

    if (!pageFiltersContext) {
      pageFiltersContext = {};
    }
    if (!pageFiltersContext[siteId]) {
      pageFiltersContext[siteId] = {};
    }
    if (!pageFiltersContext[siteId][pageName]) {
      pageFiltersContext[siteId][pageName] = {};
    }

    pageFiltersContext[siteId][pageName][currentUserId] = filters;
    this.$window.localStorage.setItem('pageFilters', angular.toJson(pageFiltersContext));
  }

  getAccountIds() {
    const siteId = this.splitService.getSiteId();
    const accountsContextService = angular.fromJson(this.$window.localStorage.getItem('accountsContextService'));
    return accountsContextService && accountsContextService[siteId] ? accountsContextService[siteId] : [];
  }

  setAccountIds(accountIds) {
    const siteId = this.splitService.getSiteId();

    let accountsContextService = angular.fromJson(this.$window.localStorage.getItem('accountsContextService'));

    if (!accountsContextService) {
      accountsContextService = {};
    }

    accountsContextService[siteId] = [];
    accountsContextService[siteId] = [].concat(accountIds);

    this.$window.localStorage.setItem('accountsContextService', angular.toJson(accountsContextService));
  }

  getBranchIds() {
    const siteId = this.splitService.getSiteId();
    const branchesContext = angular.fromJson(this.$window.localStorage.getItem('branchesContext'));
    return branchesContext && branchesContext[siteId] ? branchesContext[siteId] : [];
  }

  setBranchIds(branchIds) {
    const siteId = this.splitService.getSiteId();

    let branchesContext = angular.fromJson(this.$window.localStorage.getItem('branchesContext'));

    if (!branchesContext) {
      branchesContext = {};
    }

    branchesContext[siteId] = [];
    branchesContext[siteId] = [].concat(branchIds);

    this.$window.localStorage.setItem('branchesContext', angular.toJson(branchesContext));
  }

  getServiceAreaIds() {
    const siteId = this.splitService.getSiteId();
    const serviceAreasContext = angular.fromJson(this.$window.localStorage.getItem('serviceAreasContext'));
    return serviceAreasContext && serviceAreasContext[siteId] ? serviceAreasContext[siteId] : [];
  }

  setServiceAreaIds(serviceAreaIds) {
    const siteId = this.splitService.getSiteId();

    let serviceAreasContext = angular.fromJson(this.$window.localStorage.getItem('serviceAreasContext'));

    if (!serviceAreasContext) {
      serviceAreasContext = {};
    }

    serviceAreasContext[siteId] = [];
    serviceAreasContext[siteId] = [].concat(serviceAreaIds);

    this.$window.localStorage.setItem('serviceAreasContext', angular.toJson(serviceAreasContext));
  }

  getBillingAccountIds(): string[] {
    const siteId = this.splitService.getSiteId();
    const billingAccountsContext = angular.fromJson(this.$window.localStorage.getItem('billingAccountsContext'));
    return billingAccountsContext && billingAccountsContext[siteId] ? billingAccountsContext[siteId] : [];
  }

  setBillingAccountIds(billingAccountIds: string[]) {
    const siteId = this.splitService.getSiteId();

    let billingAccountsContext = angular.fromJson(this.$window.localStorage.getItem('billingAccountsContext'));

    if (!billingAccountsContext) {
      billingAccountsContext = {};
    }

    billingAccountsContext[siteId] = [];
    billingAccountsContext[siteId] = [].concat(billingAccountIds);

    this.$window.localStorage.setItem('billingAccountsContext', angular.toJson(billingAccountsContext));
  }

  getBillingOrderStatus(): BillingOrderStatusType {
    const siteId = this.splitService.getSiteId();
    const billingOrderStatusContext = angular.fromJson(this.$window.localStorage.getItem('billingOrderInvoiceStatusContext'));
    return billingOrderStatusContext && billingOrderStatusContext[siteId] ? billingOrderStatusContext[siteId] : undefined;
  }

  setBillingOrderStatus(billingOrderStatus: BillingOrderStatusType) {
    const siteId = this.splitService.getSiteId();

    let billingOrderStatusContext = angular.fromJson(this.$window.localStorage.getItem('billingOrderInvoiceStatusContext'));

    if (!billingOrderStatusContext) {
      billingOrderStatusContext = {};
    }

    billingOrderStatusContext[siteId] = billingOrderStatus;

    this.$window.localStorage.setItem('billingOrderInvoiceStatusContext', angular.toJson(billingOrderStatusContext));
  }

  getTags(): string[] {
    const siteId = this.splitService.getSiteId();
    const context = angular.fromJson(this.$window.localStorage.getItem('tagsContext'));
    return context && context[siteId] ? context[siteId] : [];
  }

  setTags(tags: string[]) {
    const siteId = this.splitService.getSiteId();

    let context = angular.fromJson(this.$window.localStorage.getItem('tagsContext'));

    if (!context) {
      context = {};
    }

    context[siteId] = [];
    context[siteId] = [].concat(tags);

    this.$window.localStorage.setItem('tagsContext', angular.toJson(context));
  }

  getPackagesIds(): string[] {
    const siteId = this.splitService.getSiteId();
    const context = angular.fromJson(this.$window.localStorage.getItem('packagesContext'));
    return context && context[siteId] ? context[siteId] : [];
  }

  setPackagesIds(packagesIds: string[]) {
    const siteId = this.splitService.getSiteId();

    let context = angular.fromJson(this.$window.localStorage.getItem('packagesContext'));

    if (!context) {
      context = {};
    }

    context[siteId] = [];
    context[siteId] = [].concat(packagesIds);

    this.$window.localStorage.setItem('packagesContext', angular.toJson(context));
  }

  getBillingOrderInvoiceStatuses(): InvoiceStatusType[] {
    const siteId = this.splitService.getSiteId();
    const context = angular.fromJson(this.$window.localStorage.getItem('billingOrderInvoiceStatusesContext'));
    return context && context[siteId] ? context[siteId] : [];
  }

  setBillingOrderInvoiceStatuses(billingOrderInvoiceStatuses: InvoiceStatusType[]) {
    const siteId = this.splitService.getSiteId();

    let context = angular.fromJson(this.$window.localStorage.getItem('billingOrderInvoiceStatusesContext'));

    if (!context) {
      context = {};
    }

    context[siteId] = [];
    context[siteId] = [].concat(billingOrderInvoiceStatuses);

    this.$window.localStorage.setItem('billingOrderInvoiceStatusesContext', angular.toJson(context));
  }

  getIsConsolidated(): boolean | undefined {
    const siteId = this.splitService.getSiteId();
    const context = angular.fromJson(this.$window.localStorage.getItem('isConsolidatedContext'));
    return context && typeof context[siteId] === "boolean" ? context[siteId] : undefined;
  }

  setIsConsolidated(isConsolidated: boolean) {
    const siteId = this.splitService.getSiteId();

    let context = angular.fromJson(this.$window.localStorage.getItem('isConsolidatedContext'));

    if (!context) {
      context = {};
    }
    context[siteId] = isConsolidated;

    this.$window.localStorage.setItem('isConsolidatedContext', angular.toJson(context));
  }

  getHasPrice(): boolean | undefined {
    const siteId = this.splitService.getSiteId();
    const context = angular.fromJson(this.$window.localStorage.getItem('hasPriceContext'));
    return context && typeof context[siteId] === "boolean" ? context[siteId] : undefined;
  }

  setHasPrice(hasPrice: boolean) {
    const siteId = this.splitService.getSiteId();

    let context = angular.fromJson(this.$window.localStorage.getItem('hasPriceContext'));

    if (!context) {
      context = {};
    }
    context[siteId] = hasPrice;

    this.$window.localStorage.setItem('hasPriceContext', angular.toJson(context));
  }


  getDateRangeTemplateType(): DateRangeTemplateType {
    const siteId = this.splitService.getSiteId();
    const context = angular.fromJson(this.$window.localStorage.getItem('dateRangeTemplateTypeContext'));
    return context && context[siteId] ? context[siteId] : undefined;
  }

  setDateRangeTemplateType(dateRangeTemplateType: DateRangeTemplateType) {
    const siteId = this.splitService.getSiteId();

    let context = angular.fromJson(this.$window.localStorage.getItem('dateRangeTemplateTypeContext'));

    if (!context) {
      context = {};
    }

    context[siteId] = dateRangeTemplateType;
    this.$window.localStorage.setItem('dateRangeTemplateTypeContext', angular.toJson(context));
  }
}


angular
  .module('bringoz.admin.commons')
  .service('viewFilterSettingsService', ViewFilterSettingsService);
